import FirebaseContext, {withFirebase} from './context';
import getFirebase from './firebase';

export default getFirebase;

export {FirebaseContext, withFirebase};
